/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosTab } from '../../models/pos-tab';

export interface PosTabsControllerGetById$Params {
  id: string;
}

export function posTabsControllerGetById(http: HttpClient, rootUrl: string, params: PosTabsControllerGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<PosTab>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerGetById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosTab>;
    })
  );
}

posTabsControllerGetById.PATH = '/pos/tabs/{id}';
